ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
Pollster = require './pollster'
Promise = require 'bluebird'
pollsterPromise = require './pollster-promise'
isAccountStateKnown = require './is-account-state-known'
CreditCardFormError = require './credit-card-form-error'
_ = require 'underscore'

zipCodeErrorMessage = 'U.S. addresses require a 5 or 9 digit zip code. Canadian addresses require a Postal Code.'

hasProducts = (paidAccount, products) ->
  _.intersection(paidAccount?.products ? [], products).length == products.length

isFieldError = (err) ->
  err instanceof ApiError.BadRequest &&
  (/^invalid value for /.test(err.message) || err.message.trim() == zipCodeErrorMessage)

pollsterResource = (pollster) ->
  Promise.resolve(pollster).disposer (pollster) ->
    pollster.stop()

module.exports = (postFn, pollFn, data) ->
  products = data.products?.map(parseInt) ? []

  isDonePolling = (res) ->
    isAccountStateKnown(res.paidAccount) && hasProducts(res.paidAccount, products)

  Promise.using pollsterResource(new Pollster(pollFn, 1, 1000)), (pollster) ->
    postFn()
    .cancellable()
    .catch isFieldError, ({ message }) ->
      field =
        if message.trim() == zipCodeErrorMessage
          'zipCode'
        else
          message.replace('invalid value for ', '').trim()
      Promise.reject CreditCardFormError.InvalidField('', { field })
    .catch ApiError, (err) ->
      Promise.reject CreditCardFormError.PostError('', { err })
    .then (res) ->
      if isDonePolling(res)
        res
      else
        pollsterPromise(pollster, isDonePolling)
        .catch (err) ->
          Promise.reject CreditCardFormError.PollError('', { err })



// WEBPACK FOOTER //
// ./app/scripts/views/billing/internal/submit-credit-card.coffee